<template>
    <div>
        <b-row>
            <b-col sm="12">
                <b-card no-body>
                    <b-card-body>
                        <h5 class="heading-1 mb-4">
                            <span>{{ titulo }}</span>
                            <!-- <div class="float-right">
                                <span class="text-primary">
                                    <i
                                        class="fa fa-refresh fa-lg icon-button"
                                        title="Atualizar"
                                        @click.stop="
                                            $emit('atualizar-listagem')
                                        "
                                    ></i>
                                </span>
                            </div> -->
                        </h5>
                        <app-tabela
                            :itens="consultorias"
                            :campos="campos"
                            :itensPorPagina="itensPorPagina"
                            :bordered="false"
                            :small="false"
                        >
                            <template slot="botoes">
                                <slot name="botoes"></slot>
                            </template>
                            <template slot="produtoValor" slot-scope="data">{{
                                data.produtoValor | currency
                            }}</template>
                            <template slot="idMov" slot-scope="data">
                                {{ data.idMov }}
                                <status-id-mov
                                    :consultoria="data"
                                ></status-id-mov>
                            </template>
                            <template slot="acoes" slot-scope="data">
                                <slot
                                    name="consultoriaAcoes"
                                    v-bind="data"
                                ></slot>
                            </template>
                            <template
                                slot="consultoriaSelecao"
                                slot-scope="data"
                                v-if="incluirSelecao"
                            >
                                <slot
                                    name="consultoriaSelecao"
                                    v-bind="data"
                                ></slot>
                            </template>
                        </app-tabela>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import StatusIdMov from './StatusIdMov.vue'

export default {
    components: {
        StatusIdMov
    },

    props: {
        consultorias: {
            type: Array,
            default: () => []
        },

        titulo: {
            type: String,
            default: () => 'CONSULTORIAS'
        },

        fornecedor: {
            type: Boolean,
            default: () => false
        },

        incluirSelecao: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            campos: [
                {
                    key: 'idSolicitacao',
                    label: 'Id',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'produtoDescricao',
                    label: 'Descritivo',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'dataSolicitacao',
                    label: 'Solicitada em',
                    sortable: true,
                    type: 'datetime',
                    tdClass: 'text-center'
                },
                {
                    key: 'dataContratacao',
                    label: 'Contratada em',
                    sortable: true,
                    type: 'datetime',
                    tdClass: 'text-center'
                },
                {
                    key: 'dataConclusao',
                    label: 'Concluída em',
                    sortable: true,
                    type: 'datetime',
                    tdClass: 'text-center'
                },
                {
                    key: 'produtoValor',
                    label: 'Valor',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'statusDescr',
                    label: 'Status',
                    type: 'status',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'idMov',
                    label: 'Comprometimento',
                    filterable: true
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    type: 'datetime',
                    tdClass: 'text-center'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 10
        }
    },

    created() {
        if (this.incluirSelecao) {
            this.campos.pop()
            this.campos.unshift({
                key: 'consultoriaSelecao',
                label: ''
            })
        }
    },

    methods: {},

    computed: {},

    mounted() {}
}
</script>
